/devicedetail<template>
  <div class="device-detail-stockRecord-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_device_detail_stockRecord.crkdhckgsrkgs')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 日期过滤 -->

        <el-form-item style="float: right">
          <custom-date-picker
            v-model="formSearch.timerOut"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :init-value="initUsageTimerValue"
            :picker-options="pickerOptionDisAfter"
            :start-placeholder="$t('dms_device_detail_stockRecord.ckkssj')"
            :end-placeholder="$t('dms_device_detail_stockRecord.ckjssj')"
            unlink-panels
            range-separator="——"
            style="width: 260px"
            @change="onPageChange({ page: 1 })"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-date-picker
            v-model="formSearch.timerIn"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :init-value="initUsageTimerValue"
            :picker-options="pickerOptionDisAfter"
            :start-placeholder="$t('dms_device_detail_stockRecord.rkkssj')"
            :end-placeholder="$t('dms_device_detail_stockRecord.rkjssj')"
            unlink-panels
            range-separator="——"
            style="width: 260px"
            @change="onPageChange({ page: 1 })"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :data="tableList" :index="true" :column="tableColumn" @filter="filterChange" @sort="sortChange" max-height="600"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  props: {
    deviceInfo: [String, Object, Array],
  },
  mixins: [resetFormSearchMixins],
  components: {
    // switchButton,
    // switchContainer
  },
  data() {
    return {
      tableCode: 'detail_stock_record',
      formSearch: {
        search: '',
        bodyNum: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        timerIn: '',
        inStartTime: '', // 更新开始时间
        inEndTime: '', // 更新结束时间
        timerOut: '',
        outStartTime: '',
        outEndTime: ''
      },

      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      this.formSearch.inStartTime = this.formSearch.timerIn && this.formSearch.timerIn[0] ? this.formSearch.timerIn[0] : undefined;
      this.formSearch.inEndTime = this.formSearch.timerIn && this.formSearch.timerIn[1] ? this.formSearch.timerIn[1] : undefined;
      this.formSearch.outStartTime = this.formSearch.timerOut && this.formSearch.timerOut[0] ? this.formSearch.timerOut[0] : undefined;
      this.formSearch.outEndTime = this.formSearch.timerOut && this.formSearch.timerOut[1] ? this.formSearch.timerOut[1] : undefined;
      this.$getJSON(apis.OutInRecord, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.device-detail-stockRecord-bd {
  padding: 8px 24px 24px;
}
</style>
